import bootstrapNotify from './bootstrapNotify.js';
import validators from './validators.js';
import formatters from './formatters.js';

/**
 * Valideer de ingevoerde gegevens in een formulier.
 */
var validation = {
	/** Functie die required validation toevoegd aan input */
	addRequired: function (input) {
		validation.internalAddRemoveRequired(input, true);
	},

	/** Functie die de input valideert, foutmelding toont en juiste feedback geeft */
	checkInput: async function (input) {
		/** Verkrijg de validatie van dom element */
		var validate = $(input).attr('data-validate');

		/** Knip de validaties op voor gebruik per individuele validatie (dus bijvoorbeeld required en email) */
		var validateArray = validate.split(' ');

		/** Zet inputFout default op 0 (geen fout) */
		var inputFout = 0;

		/** Definieer lege array voor de input settings in functie scope voor later gebruik */
		var inputSettings = [];

		/** Verwijder alle validatie css classes van het dom element */
		validation.removeValidationClasses(input);

		/** Valideer de value met elke aangegeven validatie type */
		$.each(validateArray, function (index, typeValidation) {
			/** Definieer validatie type op function niveau */
			validation.typeValidation = typeValidation;

			/** Als de validation required betreft en de waarde leeg is geef een error */
			if (validation.typeValidation == 'required') {
				if (input.value == '') {
					inputFout = 'error';
				}
			}

			/** Definieer de input value */
			var value = input.value;

			/** Definieer de input type */
			var type = input.type || input.tagName.toLowerCase();

			/** Als de waarde niet leeg is pas dan de gevraagde validator toe */
			if (value != '') {
				switch (validation.typeValidation) {
					case 'required':
						break;
					case 'alphanumeric':
					case 'alphabetic_dot':
					case 'alphabetic_dot_space':
					case 'alphanumeric_dot_space':
					case 'alphabetic_dot_space_add_plus_and':
					case 'alphabetic_dot_space_add_plus_and_minus':
					case 'alphanumeric_minus':
					case 'alphanumeric_dot_space_minus':
					case 'alphanumeric_dot_space_add_plus_and':
					case 'alphanumeric_dot_space_add_plus_and_minus':
					case 'alphanumeric_username':
					case 'alphabetic':
					case 'mustHaveAlphabetic':
					case 'numeric':
					case 'numericNoDecimals':
					case 'csv_only_numeric':
					case 'decimalsAllowedNoChange':
					case 'email':
					case 'daterangeTodayWarning':
					case 'daterangeTodayDanger':
					case 'datemonthyear':
					case 'kvk':
					case 'loonheffingennummer':
					case 'gsm':
					case 'phone':
					case 'mustAgree':
					case 'bsn':
					case 'iban':
					case 'nosemicolon':
					case 'lowercase':
					case 'activatieCode':
					case 'betalingskenmerk':
					case 'rsin':
						inputFout = validators[validation.typeValidation](value);
						break;
					case 'date':
						value = formatters.nullToEmptyString(value);
						inputFout = validators[validation.typeValidation](value);
						break;
					case 'decimalsAllowed':
					case 'negativeDecimalsAllowed':
					case 'decimalsAllowedPipe':
					case 'decimalsRequired':
					case 'negativeDecimalsRequired':
						value = formatters.dotToComma(value);
						inputFout = validators[validation.typeValidation](value);
						break;
					case 'postcode':
						value = formatters.removeSpaces(value);
						value = formatters.upperCase(value);
						inputFout = validators[validation.typeValidation](value);
						break;
					case 'tel':
						inputFout = validators[validation.typeValidation](input);
						break;
					case 'daterange':
						inputSettings = [$(input).attr('data-startdate'), $(input).attr('data-enddate')];
						inputFout = validators[validation.typeValidation](value, inputSettings);
						break;
					case 'daterangeNoError':
						inputSettings = [$(input).attr('data-startdate'), $(input).attr('data-enddate'), 'noError'];
						inputFout = validators[validation.typeValidation](value, inputSettings);
						break;
					case 'range':
						inputSettings = [$(input).attr('data-minvalue'), $(input).attr('data-maxvalue')];
						inputFout = validators[validation.typeValidation](value, inputSettings);
						break;
					case 'maxchar':
						inputSettings = [$(input).attr('data-maxchar')];
						inputFout = validators[validation.typeValidation](value, inputSettings);
						break;
					case 'minchar':
						inputSettings = [$(input).attr('data-minchar')];
						inputFout = validators[validation.typeValidation](value, inputSettings);
						break;
					case 'checkbox':
						inputFout = validators[validation.typeValidation](input);
						break;
					case 'password':
						inputSettings = [$(input).attr('data-password-username-target')];
						inputFout = validators[validation.typeValidation](value, inputSettings);
						break;
					case 'password2':
						inputSettings = [$('[name=password]').val()];
						inputFout = validators[validation.typeValidation](value, inputSettings);
						break;
					case 'maxFileSize':
						inputSettings = [$(input).attr('data-maxfilesize'), input.files];
						inputFout = validators[validation.typeValidation](inputSettings);
						break;
					case 'minFileSizeByte':
						inputSettings = [$(input).attr('data-minfilesizebyte'), input.files];
						inputFout = validators[validation.typeValidation](inputSettings);
						break;
					case 'fileExtension':
						inputSettings = [$(input).attr('data-fileExtension').toLowerCase()];
						inputFout = validators[validation.typeValidation](value, inputSettings);
						break;
					case 'specificValue':
						let inputSettingsJSON = $(input).attr('data-specific-value');
						inputSettings = JSON.parse(inputSettingsJSON);
						inputFout = validators[validation.typeValidation](value, inputSettings);
						break;
					case 'activatieGebruikersnaam':
						inputSettings = [$(input).attr('data-prefix')];
						inputFout = validators[validation.typeValidation](value, inputSettings);
						break;
				}

				/** Geef de input de value voor het geval dat deze geformatteerd is  */
				if (type != 'file' && type != 'password') {
					$(input).val(value);
				}

				/** Controleer of het geen geselecteerde option van een select is en zet handmatig een typeValidation tbv het ophalen van de foutmelding */
				if (type == 'select-one') {
					var selectedOption = input.options[input.selectedIndex];
					var disabled = selectedOption.disabled || false;
					if (disabled) {
						inputFout = 'error';
						validation.typeValidation = 'disabledSelectOption';
					}
				}
			}

			/** Return false als er een error (1) is */
			if (inputFout == 'error') {
				return false;
			}
		});

		if (inputFout instanceof Promise) {
			inputFout = await inputFout; // Pause until the promise resolves
		}

		/** Formatteer bij errors (1) en warnings (2) de foutmeldingen */
		if (inputFout == 'error' || inputFout == 'warning') {
			var errorLabel = validation.errorMsg[window.app.language][validation.typeValidation];

			var alternativeErrorLabel = $(input).data('validate-feedback-' + validation.typeValidation) || false;
			if (alternativeErrorLabel) {
				errorLabel = alternativeErrorLabel;
			}

			if (inputSettings != null) {
				if (inputSettings[0] != '') {
					errorLabel = errorLabel.replace('#1#', inputSettings[0]);
				}
				if (inputSettings[1] != '') {
					errorLabel = errorLabel.replace('#2#', inputSettings[1]);
				}
			}
			if ($(input).hasClass('inline-editable')) {
				$(input).closest('td').find('.invalid-tooltip').remove();
				$(input)
					.closest('td')
					.append('<div class="invalid-tooltip">' + errorLabel + '</div>');
			} else if ($(input).data('validate').includes('tel')) {
				$(input).closest('div.form-group').find('.invalid-feedback').remove();
				var hideFeedback = $(input).attr('data-validate-hide-feedback') || false;
				if (!hideFeedback) {
					$(input)
						.closest('.input-group')
						.append('<div class="invalid-feedback d-block">' + errorLabel + '</div>');
				}
			} else {
				$(input).closest('div.form-group').find('.invalid-feedback').remove();
				var hideFeedback = $(input).attr('data-validate-hide-feedback') || false;
				if (!hideFeedback) {
					$(input)
						.closest('div')
						.append('<div class="invalid-feedback d-block">' + errorLabel + '</div>');
				}
			}
		} else {
			$(input).closest('.form-group').find('.invalid-feedback').html(errorLabel).addClass('d-none');
		}

		/** Voeg bij een error (1) en een warning (2) de bijbehorende css classes toe aan het element en de form-group */
		if (inputFout == 'error') {
			$(input).closest('.form-group').addClass('has-error');
			$(input).addClass('is-invalid');
		}

		if (inputFout == 'warning') {
			$(input).closest('.form-group').addClass('has-warning');
			$(input).addClass('is-warning');
			inputFout = 0;
		}

		return inputFout;
	},

	/** Functie die input valideert onBlur */
	checkInputBlur: function () {
		validation.checkInput(this);
	},

	checkSubmitFormFieldsLoop: async function (form) {
		let errorCount = 0;

		var elements = Array.from($(form).find('input[data-validate],select[data-validate],textarea[data-validate]'));

		const result = await Promise.all(
			elements.map(async function (el) {
				const validationResult = await validation.checkInput(el);
				if (validationResult == 'error') {
					return 1;
				}
				return 0;
			})
		);

		result.forEach(function (item) {
			errorCount = errorCount + item;
		});

		return errorCount;
	},

	/** Functie die volledig formulier valideert en foutmelding toont als er validatiefouten gevonden zijn */
	checkSubmitForm: async function (form) {
		var aantalFouten = await validation.checkSubmitFormFieldsLoop(form);

		if (aantalFouten > 0) {
			if (window.app.language == 'en_US') {
				bootstrapNotify('danger', 'Please note:', 'We have detected ' + aantalFouten + ' error(s) in the form. This must be corrected before the form can be submitted.');
			} else {
				bootstrapNotify('danger', 'Let op: ', aantalFouten + ' fout(en) aangetroffen in het formulier. Deze moet gecorrigeerd worden om het formulier te versturen.');
			}
			return false;
		}

		var event = new CustomEvent('validationSuccess');

		document.dispatchEvent(event);

		return true;
	},

	/** Functie die required verwijderd en toevoegd */
	internalAddRemoveRequired: function (input, add) {
		var validate = $(input).attr('data-validate');
		if (typeof validate !== 'string') {
			validate = '';
		}
		var validateArray = validate.split(' ').filter(function (value) {
			return value != 'required';
		});
		if (add == true) {
			validateArray.unshift('required');
		}
		$(input).attr('data-validate', validateArray.join(' '));
	},

	/** Functie die required verwijderd van input */
	removeRequired: function (input) {
		validation.internalAddRemoveRequired(input, false);
	},

	/** Functie die eventueel eerder toegepaste validation css classes en foutmeldingen verwijderd */
	removeValidationClasses: function (input) {
		$(input).closest('.form-group').removeClass('has-error').removeClass('has-warning');
		$(input).removeClass('is-invalid');
		$(input).closest('.form-group').find('.invalid-feedback').html('');
	},

	/** Functie die gormulier checkt onSubmit */
	submitForm: function () {
		return validation.checkSubmitForm(this);
	},

	/** Functie die gormulier checkt onSubmit */
	submitFormOnEvent: function (e) {
		return validation.checkSubmitForm(e.target);
	},

	/** Defineer de foutmeldingen */
	errorMsg: {
		nl_NL: {
			alphabetic: 'Dit veld mag alleen letters bevatten',
			mustHaveAlphabetic: 'Dit veld moet een letter bevatten',
			alphabetic_dot: 'Dit veld mag alleen letters en punten bevatten',
			alphabetic_dot_space: 'Dit veld mag alleen letters, punten en spaties bevatten',
			alphanumeric: 'Dit veld mag alleen letters en cijfers bevatten',
			alphabetic_dot_space_add_plus_and_minus: 'Dit veld mag alleen letters, mintekens, punten, spaties en cijfers bevatten',
			alphanumeric_dot_space_add_plus_and_minus: 'Dit veld mag alleen letters, cijfers, mintekens, punten, en spaties bevatten',
			alphanumeric_minus: 'Dit veld mag alleen letters, cijfers en mintekens bevatten',
			alphanumeric_dot_space_minus: 'Dit veld mag alleen letters, mintekens, spaties en cijfers bevatten',
			alphanumeric_dot_space: 'Dit veld mag alleen letters, punten, spaties en cijfers bevatten',
			alphanumeric_username: 'Dit veld mag alleen letters, punten, streepjes, @`s en cijfers bevatten',
			numeric: 'Vul hier een geldig getal in.',
			numericNoDecimals: 'Vul een getal in zonder decimalen.',
			csv_only_numeric: 'Alleen getallen toegestaan, gescheiden door komma`s.',
			negativeDecimalsAllowed: 'Vul een geldig getal in met max 2 decimalen.',
			decimalsAllowed: 'Vul een geldig getal in met max 2 decimalen.',
			decimalsAllowedPipe: 'Vul hier geldige getal in gescheiden door een |.',
			decimalsRequired: 'Vul hier een geldig getal in met 2 decimalen.',
			negativeDecimalsRequired: 'Vul hier een geldig getal in met 2 decimalen.',
			required: 'Dit is een verplicht veld.',
			checkbox: 'Dit is een verplicht veld.',
			email: 'Vul hier een geldig e-mailadres in.',
			daterange: 'Deze datum valt niet binnen het toegestane bereik (#1# t/m #2#).',
			daterangeTodayWarning: 'De opgegeven ingangsdatum ligt in het verleden. Bij het verwerken van deze aanvraag kan de aanvraag hierop worden afgewezen, of een alternatieve ingangsdatum worden voorgesteld.',
			daterangeTodayDanger: 'De ingangsdatum mag niet in het verleden liggen.',
			date: 'Vul hier een geldige datum in (ISO-formaat).',
			datemonthyear: 'Vul hier een maand en jaar in (00-0000)',
			disabledSelectOption: 'De geselecteerde optie is niet toegestaan',
			kvk: 'Vul een geldig KVK-nummer in',
			loonheffingennummer: 'Vul een geldig loonheffingennummer in',
			range: 'Dit getal valt niet binnen het toegestane bereik (#1# t/m #2#).',
			postcode: 'Vul hier een geldige postcode in.',
			phone: 'Vul hier een geldig telefoonnummer in .',
			gsm: 'Vul hier een geldig gsm nummer in.',
			maxchar: 'Maximaal aantal karakters overschreden.',
			minchar: 'Vul het minimaal aantal gevraagde karakters in.',
			mustAgree: 'U moet hiermee akkoord gaan.',
			password: 'Uw wachtwoord of de combinatie van het wachtwoord met uw gebruikersnaam voldoet niet aan de gestelde eisen',
			password2: 'Wachtwoorden komen niet overeen.',
			bsn: 'Het bsn nummer voldoet niet aan de elf proef.',
			maxFileSize: 'Het bestand is groter dan toegestaan.',
			fileExtension: 'Niet toegestaan bestandstype. Toegestane bestandstypen: #1#.',
			specificValue: 'Deze vraag dient u met "#2#" te beantwoorden',
			iban: 'De ingevoerde IBAN is niet correct',
			nosemicolon: 'Dit veld mag geen puntkomma bevatten',
			betalingskenmerk: 'Betalingskenmerk voldoet niet aan voorwaarden',
			lowercase: 'Dit veld mag geen hoofdletters bevatten',
			activatieCode: 'De activatiecode is incorrect. Een activatiecode heeft deze opbouw: "a1234" (geen hoofdletters)',
			activatieGebruikersnaam: 'De gebruikersnaam is incorrect. Een gebruikersnaam heeft deze opbouw: "X12345678-001" (hoofdlettergevoelig)',
			rsin: 'Vul een geldig RSIN-nummer in',
			tel: 'Het telefoonnummer dat u heeft ingevoerd is ongeldig',
		},

		en_US: {
			alphabetic: 'This field can contain only alphabetic characters',
			mustHaveAlphabetic: 'This field must contain at least one alphabetic characters',
			alphabetic_dot: 'This field can contain only alphabetic characters and dots',
			alphabetic_dot_space: 'This field can contain only alphabetic characters, dots and spaces',
			alphanumeric: 'This field should only contain alphabetic characters and numbers',
			alphabetic_dot_space_add_plus_and_minus: 'This field should only contain alphabetic characters, spaces and numbers',
			alphanumeric_dot_space_add_plus_and_minus: 'This field should only contain alphabetic characters, numbers, minus, points, spaces and numbers',
			alphanumeric_minus: 'This field should only contain alphabetic characters, numers or minus signs',
			alphanumeric_dot_space_minus: 'This field should only contain alphabetic characters, minus, points, spaces and numbers',
			alphanumeric_dot_space: 'This field should only contain alphabetic characters, spaces and numbers',
			alphanumeric_username: 'This field should only contain alphabetic characters, dots, dashes, add and numbers',
			numeric: 'Please enter a valid number.',
			numericNoDecimals: 'Please enter a valid number.',
			csv_only_numeric: 'Only numbers are allowed, separated by commas.',
			negativeDecimalsAllowed: 'Please enter a valid number with max 2 decimals.',
			decimalsAllowed: 'Please enter a valid number with max 2 decimals.',
			decimalsAllowedPipe: 'Please enter a valid number divided by a |.',
			decimalsRequired: 'Please enter a valid number with 2 decimals.',
			negativeDecimalsRequired: 'Please enter a valid number with 2 decimals.',
			required: 'This value is required.',
			checkbox: 'This value is required.',
			email: 'Please enter a valid e-mail address.',
			daterange: 'The given date is not within the allowed range (#1# untill #2#).',
			daterangeTodayWarning: 'The given date is in the past. When processing this application, the application may be rejected based on this date, or an alternative date may be suggested.',
			daterangeTodayDanger: 'The given date should not be in the past.',
			date: 'Please enter a valid date (ISO-format).',
			datemonthyear: 'Please enter a month and a year (00-0000)',
			disabledSelectOption: 'The selected option is not allowed',
			kvk: 'Enter a valid CoC number',
			loonheffingennummer: 'Enter a valid payroll tax number',
			range: 'This number is not within the allowed range (#1# untill #2#).',
			postcode: 'Please enter a valid postal code.',
			phone: 'Please enter a valid phone number.',
			gsm: 'Please enter a valid mobile phone number.',
			maxchar: 'The maximum allowed characters has been reached.',
			minchar: 'Please enter the requested number of characters.',
			mustAgree: 'You must agree with this statement.',
			password: 'Your password or the combination of the password with your username does not meet the requirements.',
			password2: 'Passwords don`t match.',
			bsn: 'This BSN number does not validate.',
			maxFileSize: 'The size of this file is to large.',
			fileExtension: 'This file extension is not #1#.',
			specificValue: 'This question should be answered with "#2#"',
			iban: 'The IBAN you entered is not correct',
			nosemicolon: 'This field should not contain a semicolon',
			betalingskenmerk: 'Payment reference code does not have the correct format',
			lowercase: 'This field should not contain capital letters',
			activatieCode: 'This is not a valid activation code. An activation code has the following structure: "a1234" (case sensitive)',
			activatieGebruikersnaam: 'This is not a valid username. An username has the following structure: "X12345678-001" (case sensitive)',
			rsin: 'Enter a valid RSIN number',
			tel: 'The phone number you entered is not valid.',
		},
	},
};

export default validation;
